module.exports = __webpack_public_path__ + "img/Cedar & Elm PPP.4aad0f09.png";